export const getBuildingOptions = (buildings) =>
  buildings.map((building) => ({
    value: building.id,
    label: building.name,
  }))
